//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Field } from 'redux-form';
import ContainerRowReduxTextField from '../../components/common/ContainerRowReduxTextField'
import ContainerRowReduxCheckboxField from '../ProjectDemeter/common/ContainerRowReduxCheckboxField'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowReduxAutoCompleteAndOverrideField from '../../components/common/ContainerRowReduxAutoCompleteAndOverrideField'
import RFSelectField from '../../components/ReduxFormComps/RFSelectField';
import * as actions from '../../redux/theia/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import type { ReducerState$Type } from '../../redux/genericFlowTypes';
import type { InvoiceHeaderForm$Props } from './flowTypes'

const styles = {
    locationTextFieldStyle: {
        width: '270px',
        paddingBottom: '10px'
    },
}

const renderSubmitButton=(props:InvoiceHeaderForm$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const theia:ReducerState$Type = (props.theia:any)
    
    if (isInvalidDoc && Object.keys(theia.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        return (
            <div>
                <button type="button" onClick={()=> submitOpenActionDialog()} 
                className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
            </div>    
        )
    }
}

const autoCompleteDataSourceConfig = {
    text: "vendorName",
    value: "vendorName"
}

const depositAccountsDataSourceConfig = {
    text: "depositAccount",
    value: "depositAccount"
}

const addOrgFileSuffix=(docUrl:string)=>{
    if (docUrl.indexOf(".test")>0){
        return docUrl.replace(".test",".test/org.files")
    } else if (docUrl.indexOf(".quali")>0){
        return docUrl.replace(".quali",".quali/org.files")
    } else if (docUrl.indexOf(".prod")>0){
        return docUrl.replace(".prod",".prod/org.files")
    }
    return ""
}

const getOrgSrcLink=(docUrl:string)=>{
    if (docUrl.indexOf("static.gigsdata.com")>0){
        let newUrl = addOrgFileSuffix(docUrl)
        if (newUrl && newUrl.indexOf("-Page")>0){
            const sourceExt = newUrl.substring(newUrl.lastIndexOf("."))
            newUrl=newUrl.substring(newUrl.indexOf("-Page"),0).concat(sourceExt)
            return newUrl
        }
        return newUrl
    }

    return ""
}

class InvoiceHeaderForm extends React.Component<InvoiceHeaderForm$Props> {
    
    refreshEditData(){
        if (this.props.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.jwt,this.props.taskAcceptedInfoId)
        }
    }

    componentWillMount(){
        const { jwt, theia } = this.props
        if (!theia.vendorsLoaded){
            const populateVendorsList=(this.props.populateVendorsList:any)
            populateVendorsList(jwt);
        }
        if (!theia.depositAccountsLoaded){
            const populateDepositAccountsList=(this.props.populateDepositAccountsList:any)
            populateDepositAccountsList(jwt)
        }
    }
    
    componentDidMount(){
        this.refreshEditData()
    }

    render(){
        const { pristine,submitting,theia,isInvalidDoc,actConfDialog,jwt,taskAcceptedInfoId,isOverrideInsuranceCo,isOverrideDepositAccount, docUrl} = (this.props:any);
        const changeFieldValue = (this.props.changeFieldValue:any)
       
        if (theia.invoiceSubmitted) {
            return <Redirect to='/projectTheia/submittedForm' />;
        }
        
        const orgDocLink = getOrgSrcLink(docUrl)
        
        return (
            <div className='container'>
                <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                
                <ContainerRowReduxTextField field={'coverPageDate'} label={'Date on Cover Page'} />
                <div className='row'>
                    <div className="col-sm">
                        <div className="alert alert-primary">
                            <strong>
                                This field "Date on Cover Page" can be found in the&nbsp;
                                {orgDocLink?(<a href={orgDocLink} target='_blank' >original document</a>):'original document'} 
                            </strong>
                        </div>   
                    </div>
                </div>

                <ContainerRowReduxAutoCompleteAndOverrideField 
                    autoCompleteField={'depositAccount'} 
                    autoCompleteDatasourceConfig={depositAccountsDataSourceConfig}
                    label={'Deposit Account'}
                    datas={theia.depositAccounts}
                    checkboxField={'isOverrideDepositAccount'}
                    checkboxLabel={'Override this Deposit Account field'}
                    isOverride={isOverrideDepositAccount}
                    changeFieldValue={changeFieldValue}
                    parentProps={this.props}
                />    

                <ContainerRowReduxAutoCompleteAndOverrideField 
                    autoCompleteField={'insuranceCo'} 
                    autoCompleteDatasourceConfig={autoCompleteDataSourceConfig}
                    label={'Insurance Company'}
                    datas={theia.vendors}
                    checkboxField={'isOverrideInsuranceCo'}
                    checkboxLabel={'Override this Insurance Company field'}
                    isOverride={isOverrideInsuranceCo}
                    changeFieldValue={changeFieldValue}
                    parentProps={this.props}
                />

                <ContainerRowReduxTextField field={'checkDate'} label={'Check Date'} />
                <ContainerRowReduxTextField field={'checkNo'} label={'Check Number'} />
                <ContainerRowReduxTextField field={'checkAmount'} label={'Check Amount'} textType={'number'}  />
                <ContainerRowReduxTextField field={'fnameInsured'} label={'First Name of Insured'} />
                <ContainerRowReduxTextField field={'lnameInsured'} label={'Last Name of Insured'} />

                <ContainerRowError errorMsg={theia.error} />
                
                <div className="row">
                    <div className="col-sm">
                      {renderSubmitButton(this.props)}
                    </div>
                </div>   
            </div>    
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    const selector = ownProps.selector

    return {
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        isOverrideInsuranceCo: selector(state, 'isOverrideInsuranceCo'),
        isOverrideDepositAccount: selector(state, 'isOverrideDepositAccount')
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.morpheus, jwt, taskAcceptedInfoId))  
      },
      populateVendorsList: (jwt:string)=>{
        dispatch(actions.populateVendorsList(jwt))  
      },
      populateDepositAccountsList: (jwt:string)=>{
        dispatch(actions.populateDepositAccountsList(jwt))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderForm)


// WEBPACK FOOTER //
// ./src/views/ProjectTheia/InvoiceHeaderForm.js